
import { TableHead, TableHeader, TableRow } from "@/components/ui/table";

export function LeadsTableHeader() {
  return (
    <TableHeader>
      <TableRow>
        <TableHead>Nursing Home</TableHead>
        <TableHead>Location</TableHead>
        <TableHead>Status</TableHead>
        <TableHead>Added On</TableHead>
        <TableHead>Actions</TableHead>
      </TableRow>
    </TableHeader>
  );
}
